import { getChartConfiguration } from "./chart-configuration";
import { colors } from "./colors";
import { environments } from "./environments";

import { views } from "./helpers/views";

const percentageSetIndex = 1

/*

Datasets

Now and day (line) graph

[0] Active power of all batteries
[1] Empty set
[2] battery percentage

* Note that we need to have an empty set in the second slot of the data
  so that we don't have to juggle indexes based on user configuration.


Week, month and year (bar) graph

[0] import total
[1] Export total
[2] battery percentage

*/
const getBatteryChartConfiguration = (date, view, lang, type, fullscreen, debug = false, environment = "apps", timezone, showBatteryPercentage) => {
    let chartConfiguration = getChartConfiguration(date, view, lang, type, fullscreen, debug, environment, false, timezone)

    chartConfiguration.data.hw.showBatteryPercentage = showBatteryPercentage

    if (views[view] <= views.day && showBatteryPercentage) {

        chartConfiguration.type = 'line'

        injectPercentageDataset(chartConfiguration, debug, environment)
    }

    chartConfiguration.options.scales.xAxes[0].offset = chartConfiguration.type === 'bar'

    chartConfiguration.plugins[0].afterLayout = (chart, options) => {
        // Code that tries determine and set the background gradients of Energy graphs
        // @todo this, along many other things in "html-graph-renderer", should be refactored into something
        //    more readable, cause right now it really sucks :/
        // Calculate the right gradient for graphs based on rendered data
        let yScale = chart.scales['y-axis-0']

        let bgGradient, borderGradient

        if (views[view] <= views.day) {
            // power
            bgGradient = [
                [
                    colors.power_import.gradient_end,
                    colors.power_import.gradient_start,
                    colors.power_export.gradient_end,
                    colors.power_export.gradient_start,
                ], [
                    colors.power_export.gradient_end,
                    colors.power_export.gradient_start,
                    colors.power_import.gradient_end,
                    colors.power_import.gradient_start,
                ]
            ]

            borderGradient = [
                [
                    colors.power_import.border,
                    colors.power_export.border
                ],
                [
                    colors.power_export.border,
                    colors.power_import.border,
                ]
            ]

            const wattageDataset = chart.data.datasets[0]

            if (wattageDataset.data.length === 0) {
                return
            }

            let gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height)
            let {min, max} = wattageDataset

            const getColorStop = (val) => {
                return Math.max(0, Math.min(yScale.getPixelForValue(val || 0) / chart.height, 1))
            }

            if (min < 0 && max > 0) {
                // a dataset with positive and negative values should use a double gradient
                gradient.addColorStop(getColorStop(max), bgGradient[0][1]) // import
                gradient.addColorStop(getColorStop(0), bgGradient[0][0]) // import
                gradient.addColorStop(getColorStop(0), bgGradient[0][2]) // export
                gradient.addColorStop(getColorStop(min), bgGradient[0][3]) // export

                let bg = chart.ctx.createLinearGradient(0, 0, 0, chart.height)
                bg.addColorStop(getColorStop(0), borderGradient[0][0]) // import
                bg.addColorStop(getColorStop(0), borderGradient[0][1]) // export
                wattageDataset.borderColor = bg
            } else {
                gradient.addColorStop(getColorStop(min), bgGradient[0][min < 0 ? 3 : 0])
                gradient.addColorStop(getColorStop(max), bgGradient[0][min < 0 ? 2 : 1])
                wattageDataset.borderColor = borderGradient[0][min < 0 ? 1 : 0]
            }

            wattageDataset.backgroundColor = gradient
        } else {
            const getColorStop = (val) => Math.max(0, Math.min(yScale.getPixelForValue(val || 0) / chart.height, 1))

            const applyGradient = (dataset, gradientColor) => {
                const { min, max } = dataset

                const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height)

                gradient.addColorStop(getColorStop(min), gradientColor.gradient_end)
                gradient.addColorStop(getColorStop(max), gradientColor.gradient_start)

                dataset.backgroundColor = gradient
            }

            /**
             * IMPORT BARS
             */
            const importDataSet = chart.data.datasets[0]

            // purple border
            importDataSet.borderColor = colors.power_import.border

            // purple gradient (fill) of the import bars
            applyGradient(importDataSet, colors.power_import)


            /**
             * EXPORT BARS
             */
            const exportDataSet = chart.data.datasets[1]

            // green border
            exportDataSet.borderColor = colors.power_export.border

            // green gradient (fill)
            applyGradient(exportDataSet, colors.power_export)
        }
    }

    return chartConfiguration
}


function injectPercentageDataset(chartConfiguration, debug = false, environment = "apps") {

    const laOptions =  {
        borderCapStyle: "square",
        pointRadius: debug ? 3 : 0,
        borderWidth: 1.5,
        borderDash: [3, 10],
        // order: 0,
        data: [],
        fill: false,
        borderColor: colors.battery.charge_pct,
        // pointBorderColor: colors.battery.charge_pct,
    }

    chartConfiguration.data.datasets[percentageSetIndex] = laOptions

    // this pushes a new axis line on the left for the battery percentage value

    chartConfiguration.options.scales.yAxes.push( {
        id: 'charge',
        display: environments(environment).yAxis.display,
        position: 'left',
        stacked: false,
        weight: 1,
        gridLines: {
            display: false,
            color: debug ? 'yellow' : environments(environment).colors.gridLineColor,
            zeroLineColor: colors.gridLineColor
        },
        ticks: {
            beginAtZero: true,
            autoskip: false,
            labelOffset: -3,
            padding: 5,
            maxTicksLimit: 2,
            min: 0,
            max: 100,
            callback: (value) => `${value} %`,
        },
    })

    chartConfiguration.data.datasets[percentageSetIndex].label = 'charge'
    chartConfiguration.data.datasets[percentageSetIndex].yAxisID = 'charge'
}

export { getBatteryChartConfiguration };

